/**
 * The words for a scoring pause (PipelineStatus.scoringPaused, engine.md §6 stage B): the person's daily
 * Jev budget or the plan's limit was reached and scoring waits for the next UTC day. Used by the banner
 * and by Settings → Models → Jev.
 */

import type { PipelineStatus } from '@digester/core';
import { formatExact } from '../ui/format.js';

/** "00:00 UTC (in 5 h)". */
export function untilText(until: number, now: number = Date.now()): string {
  const hours = Math.max(1, Math.round((until - now) / 3_600_000));
  return `00:00 UTC (in ${hours} h)`;
}

export function scoringPauseText(paused: NonNullable<PipelineStatus['scoringPaused']>, now: number = Date.now()): string {
  const what = paused.reason === 'budget' ? `Today's Jev budget of ${formatExact(paused.max)} scored messages is used.` : `Today's plan limit of ${formatExact(paused.max)} scored messages is reached.`;
  return `${what} New messages wait unscored in Inbox until ${untilText(paused.until, now)}.`;
}
